import React from "react";
import { cufrontLogos } from "../../cufront-assets/logos/Logos";

const Heading = () => {
  return (
    <div className="w-full h-[57.45px] flex justify-between items-center">
      <div className="h-full flex-1">
        <img
          className="h-full object-contain"
          src={cufrontLogos.cufrontLogo}
          alt=""
        />
      </div>
      <div className="text-2xl flex-1 text-center">Help Center</div>
      <div className="flex-1"></div>
    </div>
  );
};

export default Heading;
